/* eslint-disable @typescript-eslint/no-unused-vars */
import {  Alert, Box, Button, DialogActions, DialogContent, DialogTitle, FormControl, FormControlLabel, Grid,  InputLabel,  LinearProgress,  MenuItem,  Paper, Select, Snackbar, SnackbarCloseReason, Switch } from '@mui/material';
import { useState } from 'react';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import dayjs, { Dayjs } from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { RelatorioFinanceiroService } from '../../../shared/services/api/Financeiro/Relatorios';
import RDREfazenda from './RDREporFAzenda';
           
export const RelatoriosDRE: React.FC = () => {                      
  const [isLoading, setIsLoading] = useState(false);                            
  const [dataInicial, setDataInicial] = useState<Dayjs | null>(dayjs());       
  const [dataFinal, setDataFinal] = useState<Dayjs | null>(dayjs());      
  const [openmsg, setOpenmsg] = useState(false);
  const [msg, setMsg] = useState('');
  const [tms, setTms] = useState<'warning' | 'error'  | 'info'  | 'success'>('warning');  
              
  const handleCloseMsg = (
    event?: React.SyntheticEvent | Event, 
    reason?: SnackbarCloseReason,
  ) => {                
    if (reason === 'clickaway') {                      
      return;                                                                  
    }                                                                                                    
    setOpenmsg(false);                                                                                                                                                          
  };                                                                                                                      
                                                                                                                                           
  const handleSave = () => {                                                                       
    setIsLoading(true);                         
    RelatorioFinanceiroService                  
      .DREporFazenda(dayjs(dataInicial).format('DD/MM/YYYY'), dayjs(dataFinal).format('DD/MM/YYYY'))   
      .then((result) => {           
        setIsLoading(false);                    
        if (result instanceof Error) {                                               
          setTms('error');                                           
          setMsg(result.message);                                        
          setOpenmsg(true);                                                                  
        }else {  
          RDREfazenda(result, `Período: ${dayjs(dataInicial).format('DD/MM/YYYY')} a  ${dayjs(dataFinal).format('DD/MM/YYYY')}`);                         
        }                                                                          
      });                                                                                    
  };                                                                         
                 
  return (     
    <Box  alignItems="center" width='auto' alignContent='center' height="auto"  display="flex" flexDirection="column"  >
      <Snackbar anchorOrigin={{ vertical: 'top', horizontal: 'center' }} open={openmsg}  autoHideDuration={900} onClose={handleCloseMsg}>
        <Alert
          onClose={handleCloseMsg}
          severity={tms}                         
          variant="filled"                 
          sx={{ width: '100%' }}                                                                                 
        >                                                                                 
          {msg}                                                                  
        </Alert>                                                  
      </Snackbar>
      <Box gap={1}  padding={1} paddingX={2} display="flex" alignItems="center" alignSelf='center' width='80%' height="20%" margin={1}  alignContent='center'></Box>
      <Box   width='auto' alignItems="center"  component={Paper} height="auto" margin={1} 
        alignContent='center'>       
        <DialogTitle>Resultado por Fazendas</DialogTitle>
        <DialogContent  dividers>                          
          {isLoading && (                                                                    
            <Grid item>                                                 
              <LinearProgress variant='indeterminate' />          
            </Grid>                              
          )}               
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              sx={{marginTop:2}}
              format='DD/MM/YYYY'          
              value={dataInicial}         
              onChange={(newValue) => setDataInicial(newValue)} 
              label='Data Inicial'  
              slotProps={{
                textField: {        
                  size:'small',                
                }                    
              }}      
            />              
          </LocalizationProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker  
              sx={{marginTop:2, marginLeft:2}}
              format='DD/MM/YYYY'          
              value={dataFinal}
              onChange={(newValue) => setDataFinal(newValue)} 
              label='Data Final'
              slotProps={{     
                textField: {              
                  size:'small',                    
                }     
              }}    
            />
          </LocalizationProvider>
        </DialogContent>     
        <DialogActions>
          <Button sx={{ minWidth:'30%'  }} variant='outlined' autoFocus onClick={handleSave}>Visualizar</Button>
        </DialogActions>
      </Box>
    </Box>
  );
};   